import React from "react";
import "./css/FullscreenImageModal.css";

const FullscreenImageModal = ({ imageUrl, onClose }) => {
  if (!imageUrl) return null;

  return (
    <div className="fullscreen-modal-overlay" onClick={onClose}>
      <div className="fullscreen-modal-content" onClick={(e) => e.stopPropagation()}>
        <img src={imageUrl} alt="Fullscreen View" />
        <button className="close-fullscreen-btn" onClick={onClose}>✖</button>
      </div>
    </div>
  );
};

export default FullscreenImageModal;
